import YouTubeIframeLoader from 'youtube-iframe';
import Vimeo from '@vimeo/player';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import domReady from '../helpers/dom-ready';

class ExhibitionSignLanguageVideo {
  static init() {
    return new ExhibitionSignLanguageVideo();
  }

  constructor() {
    const exhibitionHeader = document.querySelector('.exhibition-header');
    if (!exhibitionHeader) { return; }

    this.videoPlayerWrapper = exhibitionHeader.querySelector('.video-player-wrapper');
    if (!this.videoPlayerWrapper) { return; }

    this.openVideoPlayerButton = exhibitionHeader.querySelector('.open-video-player-button');
    this.closeVideoPlayerButton = exhibitionHeader.querySelector('.close-video-player-button');

    this.videoType = this.videoPlayerWrapper.dataset.videoType;

    this.videoPlayerIsVisible = false;

    this.addEventListeners();

    if (this.videoType === 'youtube') {
      this.youtubePlayer = this.videoPlayerWrapper.querySelector('.youtube-player');
      this.initYotube();
    }

    if (this.videoType === 'vimeo') {
      this.vimeoPlayer = this.videoPlayerWrapper.querySelector('.vimeo-player');
      this.initVimeo();
    }
  }

  addEventListeners() {
    this.openVideoPlayerButton.addEventListener('click', () => {
      this.openVideoPlayer();
    });

    this.closeVideoPlayerButton.addEventListener('click', () => {
      this.closeVideoPlayer();
    });

    window.addEventListener('keyup', (e) => { this.onKeyup(e); });
  }

  openVideoPlayer() {
    this.videoPlayerIsVisible = true;
    this.videoPlayerWrapper.classList.remove('-hidden');
    disableBodyScroll(this.videoPlayerWrapper);
    // TODO: Make other buttons disabled?
  }

  closeVideoPlayer() {
    this.videoPlayerIsVisible = false;
    this.pauseVideo();
    this.videoPlayerWrapper.classList.add('-hidden');
    enableBodyScroll(this.videoPlayerWrapper);
    // TODO: Make other buttons enabled?
  }

  onKeyup(e) {
    if (e.key === 'Escape' && this.videoPlayerIsVisible) {
      this.closeVideoPlayer();
    }

    if (e.key === 'Tab') {
      if (document.activeElement.parentElement !== this.videoPlayerWrapper) {
        this.closeVideoPlayerButton.focus();
      }
    }
  }

  initYotube() {
    YouTubeIframeLoader.load((YT) => {
      this.youtube = new YT.Player(this.youtubePlayer, {
        height: '100%',
        width: '100%',
        videoId: this.youtubePlayer.dataset.videoId,
        playerVars: {
          color: 'white',
          rel: 0, // Only show related videos from same channel
          playsinline: 1,
        },
      });
    });
  }

  initVimeo() {
    this.vimeo = new Vimeo(this.vimeoPlayer);
  }

  pauseVideo() {
    if (this.videoType === 'vimeo') {
      this.vimeo.pause();
    } else {
      this.youtube.pauseVideo();
    }
  }
}

domReady(() => {
  ExhibitionSignLanguageVideo.init();
});
